/**
 * @file
 * Header toggling functionality.
 */

(($, { behaviors }) => {
  /**
   * Focus trap functionality.
   *
   * Focus is trapped inside the site's header once it is opened. If navigating
   * forth and back with the tab key, navigation occurs only inside the site's
   * header, elements outside the site's header is only accessible again once
   * the site's header is closed either by pressing the 'X' icon or by pressing
   * escape.
   *
   * @param {Element} element
   *   The element the focus trap is applied on.
   */
  function initiateFocusTrap(element) {
    element.focus();
    const $subMenuToggle = $(".js-menu__toggle");
    const $siteOverlay = $(".js-site-overlay");
    const arrowUp = 38;
    const arrowDown = 40;
    const tabKey = 9;
    const breakpointLarge = "(max-width: 1100px)";
    let focusableElements = element.find(
      $("a[href]:visible:not([disabled]), button:not([disabled])")
    );
    const firstFocusableElement = focusableElements[0];
    let lastFocusableElement = focusableElements[focusableElements.length - 1];

    firstFocusableElement.focus();

    /**
     * Handle tab interaction when focus is in the header.
     */
    element.on("keydown", (e) => {
      const isTabPressed = e.key === "Tab" || e.keyCode === tabKey;

      if (window.matchMedia(breakpointLarge).matches) {
        if (!isTabPressed) {
          return;
        }

        if (e.shiftKey) {
          if (document.activeElement === firstFocusableElement) {
            lastFocusableElement.focus();
            e.preventDefault();
          }
        } else if (document.activeElement === lastFocusableElement) {
          firstFocusableElement.focus();
          e.preventDefault();
        }
      }
    });

    /**
     * Updates the array of focusable elements.
     */
    function updateFocusableElements() {
      // We add a timeout to make sure the submenu is displayed as block before
      // we update the focusableEls.
      setTimeout(() => {
        focusableElements = element.find(
          $("a[href]:visible:not([disabled]), button:not([disabled])")
        );
        lastFocusableElement = focusableElements[focusableElements.length - 1];
      }, 150);
    }

    /**
     * Update focusable elements when a submenu is expanded.
     */
    $subMenuToggle.on("click keydown", (event) => {
      if (event.type === "keydown") {
        if (event.keyCode === arrowUp || event.keyCode === arrowDown) {
          updateFocusableElements();
        }
      } else if (event.type === "click") {
        updateFocusableElements();
      }
    });

    /**
     * Focus first element if cli
     */
    $siteOverlay.on("click", () => {
      firstFocusableElement.focus();
    });
  }

  /**
   * Open header.
   *
   * @param {jQuery} $siteHeader
   *   A site header DOM element.
   * @param {jQuery} $siteOverlay
   *   A site overlay DOM element.
   * @param {jQuery} $headerOpen
   *   A header open button DOM element.
   * @param {jQuery} $body
   *   A body DOM element.
   */
  function openHeader($siteHeader, $siteOverlay, $headerOpen, $body) {
    $body = $("body");
    $siteHeader.addClass("is-open");
    $siteOverlay.addClass("is-visible");
    $siteHeader.attr("aria-expanded", "true");
    $body.css("overflow", "hidden");

    function onVisible(element, callback) {
      new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (entry.intersectionRatio > 0) {
            callback(element);
            observer.disconnect();
          }
        });
      }).observe(element);
      if (!callback)
        return new Promise((r) => {
          callback = r;
        });
    }

    onVisible($("js-header__inner"), initiateFocusTrap($siteHeader));
  }

  /**
   * Close header.
   *
   * @param {jQuery} $siteHeader
   *   A site header DOM element.
   * @param {jQuery} $siteOverlay
   *   A site overlay DOM element.
   * @param {jQuery} $headerOpen
   *   A header open button DOM element.
   * @param {jQuery} $body
   *   A body DOM element.
   */
  function closeHeader($siteHeader, $siteOverlay, $headerOpen, $body) {
    $siteHeader.removeClass("is-open");
    $siteOverlay.removeClass("is-visible");
    $headerOpen.attr("aria-expanded", "false");
    $body.css("overflow", "");
  }

  /**
   * Attaches behaviors for header toggling.
   *
   * @type {Drupal~behavior}
   *
   * @prop {Drupal~behaviorAttach} attach
   *  Attaches header toggling functionality.
   */
  behaviors.headerToggle = {
    attach(context) {
      const $siteHeader = $(".js-header", context);
      const $siteOverlay = $(".js-site-overlay", context);
      const $headerOpen = $(".js-header-open", context);
      const $headerClose = $(".js-header-close", context);
      const $body = $(".js-body", context);
      const escKeyCode = 27;

      $siteHeader.on("keydown", (e) => {
        const isEscPressed = e.key === "Esc" || e.keyCode === escKeyCode;

        if (isEscPressed) {
          closeHeader($siteHeader, $siteOverlay, $headerOpen, $body);
        }
      });

      $headerOpen.click(() => {
        openHeader($siteHeader, $siteOverlay, $headerOpen, $body);
      });

      $headerClose.click(() => {
        closeHeader($siteHeader, $siteOverlay, $headerOpen, $body);
      });
    }
  };
})(jQuery, Drupal);
